import { Controller, ActionEvent } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static classes = ["active"]
  declare readonly activeClass: string

  static targets = ["button", "slide"]
  declare readonly buttonTargets: HTMLButtonElement[]
  declare readonly slideTargets: HTMLElement[]

  open({ params: { id } }: ActionEvent): void {
    this.buttonByControls(id).setAttribute("aria-expanded", "true")
    this.slideById(id).classList.add(this.activeClass)
  }

  close({ params: { id } }: ActionEvent): void {
    this.buttonByControls(id).setAttribute("aria-expanded", "false")
    this.slideById(id).classList.remove(this.activeClass)
  }

  closeAll(): void {
    this.buttonTargets.forEach((button) => {
      button.setAttribute("aria-expanded", "false")
    })
    this.slideTargets.forEach((slide) => {
      slide.classList.remove(this.activeClass)
    })
  }

  private buttonByControls(id: string): HTMLButtonElement {
    return this.buttonTargets.find((button) => button.getAttribute("aria-controls") === id)!
  }

  private slideById(id: string): HTMLElement {
    return this.slideTargets.find((slide) => slide.id === id)!
  }
}
